module.exports = __webpack_public_path__ + "static/media/Pagos.b35fc9f9.png";